<script>
import { Overlay } from 'trading-vue-js'

export default {
    name: 'Trend',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return { author: '', version: '' }
        },
        // Here goes your code. You are provided with:
        // { All stuff is reactive }
        // $props.layout -> positions of all chart elements +
        //  some helper functions (see layout_fn.js)
        // $props.interval -> candlestick time interval
        // $props.sub -> current subset of candlestick data
        // $props.data -> your indicator's data subset.
        //  Comes "as is", should have the following format:
        //  [[<timestamp>, ... ], ... ]
        // $props.colors -> colors (see TradingVue.vue)
        // $props.cursor -> current position of crosshair
        // $props.settings -> indicator's custom settings
        //  E.g. colors, line thickness, etc. You define it.
        // $props.num -> indicator's layer number (of All
        // layers in the current grid)
        // $props.id -> indicator's id (e.g. EMA_0)
        // ~
        // Finally, let's make the canvas dirty!
        draw(ctx) {
            // console.log("draw trend overlay");
            const layout = this.$props.layout
            const data = this.$props.data
            ctx.lineWidth = this.line_width;
            let prevX = null;
            let prevY = null;
            for (var k = 0, n = data.length; k < n; k++) {
                let p = data[k]
                let x = layout.t2screen(p[0])
                let y = layout.$2screen(p[1])
                if(prevX && prevY){
                    ctx.beginPath()
                    ctx.moveTo(prevX, prevY)
                    ctx.strokeStyle = this.gray;
                    if(p[2] === "green") ctx.strokeStyle = this.green;
                    if(p[2] === "red") ctx.strokeStyle = this.red;
                    if(p[2] === "blue") ctx.strokeStyle = this.blue;
                    ctx.lineTo(x, y)
                    ctx.stroke()
                }
                prevX = x;
                prevY = y;
            }
        },

        use_for() { return ['Trend'] },
        data_colors() { return [ "#8c8c8c"] }
    },
    // Define internal setting & constants here
    computed: {
        sett() {
            return this.$props.settings
        },
        line_width() {
            return this.sett.lineWidth || 0.75
        },
        green(){
            return this.sett.colorGreen || '#42b28a'
        },
        red(){
            return this.sett.colorRed || '#ff2316'
        },
        gray(){
            return this.sett.color || '#d3dde1'
        },
        blue(){
            return this.sett.colorBlue || '#4d9ef6'
        }
    },
    data() {
        return {

        }
    }

}
</script>
